import Axios from 'axios'

import Store from '../store'
import REQUEST_HEADERS from './request-headers'

const AxiosBuilder = {
    /**
     * @type {?string}
     */
    domain: null,

    /**
     * Sets the base domain for all API requests.
     *
     * @param {string} domain
     */
    setDomain(domain) {
        this.domain = domain
    },

    /**
     * Builds an instance of axios with base URL.
     *
     * @param {string} [baseUrl='/'] The base URL to use for all requests on this instance.
     * @returns {AxiosInstance} An axios instance.
     */
    build(baseUrl = '/') {
        return Axios.create({
            baseURL: this.domain + baseUrl,
        })
    },

    /**
     * Returns the value of header from the store.
     *
     * @params {string} headerName
     * @returns {?string}
     */
    getHeaderValue(headerName) {
        switch (headerName) {
            case REQUEST_HEADERS.SESSION_TOKEN:
                return Store.state.requestToken ? Store.state.requestToken.token : null
            case REQUEST_HEADERS.BEARER_TOKEN:
                return Store.state.authContext ? `Bearer ${ Store.state.authContext.rawToken }` : null
            default:
                return null
        }
    },

    /**
     * Creates a header object with the predefined system header names, sets the values from the store
     * and returns a key value pair of headers.
     *
     * @params {string[]} headerNames
     * @returns {Object}
     */
    buildHeaders(headerNames = []) {
        const retObj = {}

        headerNames.forEach(name => {
            retObj[name] = this.getHeaderValue(name)
        })

        return retObj
    },
}

export default AxiosBuilder
